/** Base styled-system mixin every primitive component extends. */
import {
  AlignSelfProps,
  BorderColorProps,
  BordersProps,
  ColorProps,
  DisplayProps,
  FlexProps,
  FontSizeProps,
  HeightProps,
  MaxHeightProps,
  MaxWidthProps,
  MinHeightProps,
  MinWidthProps,
  OrderProps,
  SpaceProps,
  WidthProps,
  alignSelf,
  borderColor,
  borders,
  color,
  compose,
  display,
  flex,
  fontSize,
  height,
  maxHeight,
  maxWidth,
  minHeight,
  minWidth,
  order,
  space,
  width,
} from 'styled-system';

/** Union of every styled-system prop the `base` mixin understands. */
export type BaseStyleProps =
  & SpaceProps
  & WidthProps
  & MinWidthProps
  & MaxWidthProps
  & HeightProps
  & MinHeightProps
  & MaxHeightProps
  & DisplayProps
  & FontSizeProps
  & FlexProps
  & OrderProps
  & AlignSelfProps
  & ColorProps
  & BordersProps
  & BorderColorProps;

/**
 * Resolves a theme key into the value at `theme[key]` for a styled-component prop.
 * Return is typed `any` because theme entries are arbitrarily-shaped CSS-in-JS payloads
 * that styled-components' `Interpolation` type can't usefully constrain.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const themed = <Key extends string>(key: Key) =>
  (props: { theme: Record<string, any> }): any => props.theme[key];

export const base = compose(
  () => ({ boxSizing: 'border-box' as const }),
  space,
  width,
  minWidth,
  maxWidth,
  height,
  minHeight,
  maxHeight,
  fontSize,
  color,
  flex,
  order,
  alignSelf,
  borders,
  borderColor,
  display
);
